export default function ResetSuccess() {
  return (
    <div style={{ textAlign: "center", padding: "60px" }}>
      <h1>✅ Password Reset Successful</h1>
      <p>You can now login with your new password.</p>
      <a href="/login">Go to Login</a>
    </div>
  );
}
